module.exports = __webpack_public_path__ + "img/DK38172433.a328a158.png";